import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="brand-name">Pathway Labs, Inc.</span>
            </Link>
            <p className="footer-tagline">Infrastructure for human-centered systems.</p>
          </div>

          <nav className="footer-nav">
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/solutions">Solutions</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
        </div>

        <div className="footer-disclaimers">
          <p className="disclaimer-text">
            This website and its contents are for informational purposes only.
            Pathway Labs does not provide legal, financial, or tax advice.
            Workflow automation and compliance-oriented tools are intended as aids
            and do not ensure adherence to any regulatory requirement.
            All data and information remain the responsibility of the organizations who use our tools.
          </p>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; 2025 Pathway Labs. All rights reserved.
          </p>
          <nav className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="divider">|</span>
            <Link to="/terms">Terms of Use</Link>
            <span className="divider">|</span>
            <Link to="/security">Security Statement</Link>
            <span className="divider">|</span>
            <Link to="/contact">Contact Us</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
